"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _TitleModule = _interopRequireDefault(require("../../styles/components/Card/Title.module.css"));
var _selectors = require("../../redux/selectors");
var _material = require("@mui/material");
const _excluded = ["equipmentType", "equipmentName", "buildings", "displayNameId"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const Title = _ref => {
  let {
    title: propTitle = '',
    thingPDIDDevice = null
  } = _ref;
  const activeT = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const allBuildings = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.selectBuildings) || [];
  const _ref2 = (0, _reactRedux.useSelector)((0, _selectors.selectDeviceByPdid)(thingPDIDDevice), function () {
      let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return !(prev.equipmentType !== next.equipmentType || prev.equipmentName !== next.equipmentName || prev.buildings !== next.buildings);
    }) || {},
    {
      equipmentType = '',
      equipmentName = '',
      buildings = [],
      displayNameId = []
    } = _ref2,
    d = _objectWithoutProperties(_ref2, _excluded);
  const [showTitle, setShowTitle] = (0, _react.useState)(false);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const tVDisplayNameId = (0, _reactRedux.useSelector)(store => {
    var _selectors$getActiveT;
    return (_selectors$getActiveT = _paulCorePackage.selectors.getActiveTranslationsValues(store)) === null || _selectors$getActiveT === void 0 || (_selectors$getActiveT = _selectors$getActiveT[equipmentType]) === null || _selectors$getActiveT === void 0 ? void 0 : _selectors$getActiveT.displayNameId;
  });
  const tPwcPoe = (0, _react.useMemo)(() => {
    var _activeT$Default;
    return (activeT === null || activeT === void 0 || (_activeT$Default = activeT.Default) === null || _activeT$Default === void 0 ? void 0 : _activeT$Default.equipmentType.PwcPoe) || '';
  }, [activeT]);
  const buildingName = (0, _react.useMemo)(() => _paulCorePackage.functions.getBuildingName({
    device: {
      buildings
    },
    allBuildings
  }), [buildings, allBuildings]);
  const temperatureDisplayNameIdList = displayNameId.filter(id => _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex.test(id));
  const title = (0, _react.useMemo)(() => {
    if (propTitle) return propTitle;
    const temperatureTranslateText = temperatureDisplayNameIdList.map(id => (tVDisplayNameId === null || tVDisplayNameId === void 0 ? void 0 : tVDisplayNameId[id]) || '--').join(', ');
    const postfix = temperatureTranslateText ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, temperatureTranslateText)) : '';
    if (equipmentType === _paulCorePackage.constants.ComponentTypes.PwcPoe && !equipmentName) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "".concat(tPwcPoe, " ").concat(buildingName), " ", postfix);
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tV(equipmentName), postfix);
  }, [equipmentType, tV, tPwcPoe, buildingName, equipmentName, temperatureDisplayNameIdList, tVDisplayNameId]);
  const checkHidden = (0, _react.useCallback)(function () {
    let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const curOverf = el === null || el === void 0 ? void 0 : el.style.overflow;
    if (!curOverf || curOverf === 'visible') {
      el.style.overflow = 'hidden';
    }
    el.style.overflow = curOverf;
    return _paulCorePackage.functions.textIsPlacedInBlock(el);
  }, []);
  (0, _react.useEffect)(() => {
    const title = document.querySelector("#title_".concat(thingPDIDDevice));
    if (title) setShowTitle(checkHidden(title));
  }, [thingPDIDDevice, checkHidden]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: _TitleModule.default.name_wrap
  }, showTitle ? /*#__PURE__*/_react.default.createElement(_paulCorePackage.TooltipWrap, {
    text: title
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    id: "title_".concat(thingPDIDDevice),
    className: _TitleModule.default.name
  }, title)) : /*#__PURE__*/_react.default.createElement(_material.Box, {
    id: "title_".concat(thingPDIDDevice),
    className: _TitleModule.default.name
  }, title)), [title, showTitle, thingPDIDDevice]);
};
var _default = exports.default = Title;